var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBounce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 13,
    viewBox: "0 0 25 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.15118C0.0705202 1.05037 0.115233 0.938536 0.193261 0.840882C0.30757 0.697825 0.743865 0.21848 0.876659 0.133262C1.1317 -0.0304107 1.27661 -0.0487039 1.53316 0.124139L12.2675 9.87067L20.934 2.06167H18.9414C18.8737 2.06167 18.6121 1.93021 18.5602 1.86713C18.4005 1.67321 18.3964 0.675367 18.4483 0.419394C18.4895 0.216146 18.6628 0.0669971 18.8564 0.0120755L24.08 0C24.35 0.0324333 24.4521 0.173726 24.583 0.384464V5.75152C24.4694 5.91794 24.3843 6.0794 24.1639 6.12391C23.9075 6.1757 22.9077 6.17163 22.7134 6.01222C22.6502 5.96038 22.5184 5.69932 22.5184 5.63172V3.45135L12.9385 12.0279C12.4244 12.3922 11.9999 12.3364 11.5227 11.9577C7.9162 8.51295 4.03091 5.34384 0.431457 1.89462C0.270677 1.74055 0.102011 1.59033 0 1.39079V1.15118Z",
    fill: "#919090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounce);
export default __webpack_public_path__ + "static/media/bounce.af0657643023b70cfe52037a173a926c.svg";
export { ForwardRef as ReactComponent };